import axios from "axios";
import Config from "../utils/Config";

class ConferenceTradeMissionService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      },
    };
  }

  async getConferencesAndTradeMissions() {
    try {
      const response = await axios.get(
        `${Config.API_BASE_URL}/admin/media/conferences-trade-missions`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data?.reason || "Fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.reason ||
          "An error occurred while fetching data",
      };
    }
  }

  async getConferenceTradeMission(slug) {
    try {
      const response = await axios.get(
        `${Config.API_BASE_URL}/admin/media/conferences-trade-missions/${slug}`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data?.reason || "Fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.reason ||
          "An error occurred while fetching data",
      };
    }
  }

  async createConferenceTradeMission(payload) {
    try {
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/create/event`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data,
        message: response.data?.data?.reason || "Created successfully",
      };
    } catch (error) {
      const errorData = error?.response?.data;
      let errorMessage = "An Error Occurred whiles creating a conference or trade mission"
      if(errorData){
        if(errorData?.message){
          errorMessage = errorData?.message;
        }
        else if(errorData?.reason){
          errorMessage = errorData?.reason;
        }
      }else if(error?.response?.message){
        errorMessage = error?.response?.message;
      }
      return {
        status: false,
        data: null,
        message: errorMessage,
        errors: errorData?.errors || null,
      };
    }
  }

  async updateConferenceTradeMission(slug, payload) {
    try {
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/media/conferences-trade-missions/update/${slug}`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data,
        message: response.data?.data?.reason || "Updated successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.reason ||
          "An error occurred while updating",
      };
    }
  }

  async deleteConferenceTradeMission(slug) {
    try {
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/media/conferences-trade-missions/delete/${slug}`,
        {},
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data,
        message: response.data?.data?.reason || "Deleted successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.reason ||
          "An error occurred while deleting",
      };
    }
  }

  async rescheduleConferenceTradeMission(slug, payload) {
    try {
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/media/conferences-trade-missions/reschedule/${slug}`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data,
        message: response.data?.data?.reason || "Rescheduled successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.reason ||
          "An error occurred while rescheduling",
      };
    }
  }

  async cancelConferenceTradeMission(slug, payload) {
    try {
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/media/conferences-trade-missions/cancel/${slug}`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data,
        message: response.data?.data?.reason || "Cancelled successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.reason ||
          "An error occurred while cancelling",
      };
    }
  }

  async markAsClosed(slug) {
    try {
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/media/conferences-trade-missions/close/${slug}`,
        {},
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data,
        message: response.data?.data?.reason || "Marked as closed",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.reason ||
          "An error occurred while closing",
      };
    }
  }
}

const conferenceTradeMissionService = new ConferenceTradeMissionService();
export default conferenceTradeMissionService;

